import { ICONS } from '@Const/common'
import React from 'react'
import { NavLink } from 'react-router'
import './index.scss'
import clsx from 'clsx'

export interface ExpandableItemHeaderProps {
    icon?: keyof typeof ICONS
    heading: string
    className?: string
    onClick?: () => void
    isExpanded?: boolean
    link?: string
}

const ExpandableItemHeader = ({ icon, heading, className, onClick, isExpanded, link }: ExpandableItemHeaderProps) => {
    const IconHeading = icon ? (
        <>
            <div className="icon-container">
                <img src={icon} alt={heading} />
            </div>
            <span>{heading}</span>
        </>
    ) : (
        <>
            <span>
                <strong>{heading}</strong>
            </span>
        </>
    )
    return (
        <div
            className={clsx(
                'expandable-item-header',
                !link && onClick && 'expandable-item-header-clickable',
                className
            )}
            onClick={link ? undefined : onClick}
        >
            <>
                {link ? <NavLink to={link}>{IconHeading}</NavLink> : <>{IconHeading}</>}
                {isExpanded !== undefined && (
                    <img
                        src={isExpanded ? ICONS.chevron_drop_up : ICONS.chevron_drop_down}
                        onClick={(event) => {
                            event.stopPropagation()
                            onClick && onClick()
                        }}
                        alt="expand"
                    />
                )}
            </>
        </div>
    )
}

export default ExpandableItemHeader
